import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgSignInImage',
})
export default class CmgSignInImage extends Vue {

  get userIsGuacMode(): boolean {
    return this.$appStore.getters.isCustomerGuacMode;
  }

  get isUserEnrolledInLoyalty(): boolean {
    const customer = this.$appStore.state.customer.profile;
    return this.$services.loyalty.isEnrolledInLoyalty(customer);
  }

  get iconHaloGuacMode(): string {
    const icons = this.$appStore.state.cms.images.icons;
    return icons.userOutlineHaloGuacMode.default;
  }

  get iconHaloMode(): string {
    const icons = this.$appStore.state.cms.images.icons;
    return icons.userOutlineHalo.default;
  }

}
